/** @format */

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductListCompareService, ProductListSnackbarService } from '@plp/data-access/services';
import {
	addCompareProduct,
	removeCompareProduct,
	setCompareProducts
} from '../compare/compare.actions';
import { tap, withLatestFrom } from 'rxjs';

import { COMPARE_PRODUCT_LIST_LIMIT } from '@plp/data-access/constants';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCompareProducts } from './compare.selectors';

@Injectable()
export class CompareEffects {
	setCompareProducts$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(addCompareProduct),
				withLatestFrom(this.store.select(selectCompareProducts)),
				tap(([, compareProducts]) => {
					if (compareProducts.length > COMPARE_PRODUCT_LIST_LIMIT) {
						// Error path
						this.plpSnackbarService.openSnackbar(
							'Only 5 products can be added to compare. Please remove a product before making another selection.'
						);
						const compareProductsCopy = [...compareProducts];
						compareProductsCopy.pop();
						this.store.dispatch(
							setCompareProducts({ compareProducts: compareProductsCopy })
						);
						return;
					}
					this.compareService.updateSessionStorage(compareProducts);
				})
			),
		{ dispatch: false }
	);

	removeCompareProduct$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(removeCompareProduct),
				withLatestFrom(this.store.select(selectCompareProducts)),
				tap(([action, compareProducts]) => {
					const productsAfterRemoval = compareProducts.filter(
						(cp) => cp.ecode !== action.ecode
					);
					this.store.dispatch(
						setCompareProducts({ compareProducts: productsAfterRemoval })
					);
					this.compareService.updateSessionStorage(productsAfterRemoval);
				})
			),
		{ dispatch: false }
	);

	constructor(
		private readonly plpSnackbarService: ProductListSnackbarService,
		private readonly compareService: ProductListCompareService,
		private readonly actions$: Actions,
		private readonly store: Store
	) {}
}
